"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseAPI_1 = require("./BaseAPI");
var AdsTxtReportAPI = /** @class */ (function (_super) {
    tslib_1.__extends(AdsTxtReportAPI, _super);
    function AdsTxtReportAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdsTxtReportAPI.prototype.getAll = function (demandPartners, type) {
        if (demandPartners === void 0) { demandPartners = []; }
        return this.request({
            method: "get",
            url: "/api/ads_txt_health_report/",
            params: { demandPartners: demandPartners, type: type }
        });
    };
    AdsTxtReportAPI.prototype.getDemandPartners = function () {
        return this.request({
            method: "get",
            url: "/api/ads_txt_health_report/get_demand_partners/"
        });
    };
    return AdsTxtReportAPI;
}(BaseAPI_1.default));
exports.default = new AdsTxtReportAPI(window.__BASE_API_URL__);
